// import 'svgxuse'; // Uncomment to support svg icons on IE

import { createPopper } from "@popperjs/core";
import * as bootstrap from "bootstrap";
import "./components/header";
import "./components/loadmore";
import "./components/partnersearch";
import "./components/smooth-scroll";
import "./components/eaplus";
import "./components/autocomplete";
import "./components/sliders";
import "./blocks/comparison";
import "./blocks/custom-cart";
import "./blocks/plan-addons";
import "./blocks/partner-search";
import "./blocks/help-me-choose";
import "./pages/checkout";

// BS Tooltip init
const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

// BS Scrollspy init
const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: "#js-scrollspy",
  rootMargin: "0px 0px -75% 0px",
});

// Update WC scroll_to_notices
jQuery(function ($) {
  $.scroll_to_notices = function (scrollElement) {
    if (scrollElement.length) {
      $("html, body").animate({ scrollTop: 0 }, 1000);
    }
  };
});
